export enum chartTypes {
  burndown = 'burndown',
  burnup = 'burnup',
  velocity = 'velocity',
  pie = 'pie'
}